const BREAKDOWN_OPTIONS = [
  { value: 'InteractionType', label: 'by type', filterField: 'interactionType' },
  { value: 'AssociatedUserIds', label: 'by teammate', filterField: 'associatedUserIds' },
  { value: 'InitiatedByOrganisation', label: 'by initiator', filterField: 'initiatedByOrganisation' },
  { value: 'Tags', label: 'by tag', filterField: 'tags' },
];

// interactionType is indexed lowercase in Elasticsearch ("email", "phone call", ...); this maps the
// raw bucket key back to the display label used everywhere else in the product.
const TYPE_DISPLAY_LABELS = {
  email: 'Email',
  meeting: 'Meeting',
  'phone call': 'Phone call',
  'social media': 'Social media',
  events: 'Event',
  other: 'Other',
};

// `bucket` is whatever Elasticsearch returned as the terms-aggregation key: a lowercase interaction
// type string, a numeric user id (as a string), the string "true"/"false", or a raw tag string.
const resolveBreakdownLabel = ({ breakdownBy, bucket, teamMembers, teamName }) => {
  if (breakdownBy === 'InteractionType') {
    return TYPE_DISPLAY_LABELS[bucket?.toLowerCase()] ?? bucket;
  }
  if (breakdownBy === 'AssociatedUserIds') {
    const member = teamMembers?.find((item) => `${item.id}` === `${bucket}`);
    return member?.fullName ?? bucket;
  }
  if (breakdownBy === 'InitiatedByOrganisation') {
    return `${bucket}`.toLowerCase() === 'true' ? (teamName ?? 'Us') : 'Stakeholder';
  }
  return bucket;
};

const sumSeries = (series) => (series.datapoints ?? []).reduce((total, point) => total + (point.value ?? 0), 0);

const sortBreakdownByQuantity = (breakdown) => [...(breakdown ?? [])].sort((a, b) => sumSeries(b) - sumSeries(a));

export { BREAKDOWN_OPTIONS, resolveBreakdownLabel, sortBreakdownByQuantity };
